import React from 'react'
import PropTypes from 'prop-types'
import { ACCESSIBILITY_CLASSES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const Links = ({ data, themeColorHex }) => {
  return data && (
    <ul className="links">
    {
      data.map((link, index) => {
        return link.text && (
          <li key={index}>
            <a href={link.url} target="_blank" style={{color: themeColorHex}} rel="noopener noreferrer" className={`${ACCESSIBILITY_CLASSES.main}`}>
              {link.text}
            </a>
          </li>
        )
      })
    }
    </ul>
  )
}

Links.propTypes = {
  data: PropTypes.array,
  themeColorHex: PropTypes.string.isRequired
}

export default Links

